import { withI18nextProvider } from './withI18nextProvider';
export function withSharedComponentProviders(Comp) {
    return withI18nextProvider(Comp);
}
//# sourceMappingURL=index.js.map